import { render } from "./ResultImage.vue?vue&type=template&id=64e6e284&scoped=true"
import script from "./ResultImage.vue?vue&type=script&lang=js"
export * from "./ResultImage.vue?vue&type=script&lang=js"

import "./ResultImage.vue?vue&type=style&index=0&id=64e6e284&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e6e284"]])

export default __exports__